import ReactMarkdown from "react-markdown";
import { ArtifactTable, ArtifactStat, ArtifactChart } from "@components/ChatbotV2/components/MessageList";
import ArtifactErrorBoundary from "@components/ChatbotV2/components/ArtifactErrorBoundary";
import InsightsCard from "@components/ChatbotV2/components/InsightsCard";
import type { InsightsData } from "@components/ChatbotV2/types";
import type { MessagePart } from "../Processing/types";
// The chat artifact components are styled by the chat page's stylesheet; the
// tile renders them outside it, so it has to bring the styles along.
import "@components/ChatbotV2/styles.css";

/**
 * One rendered assistant turn at tile width, using the chat page's own artifact
 * components so a widget answer and a chat answer can't drift apart. A part
 * whose data is malformed takes down its own box, not the tile.
 */
export function AiWidgetParts({ parts }: { parts: MessagePart[] }) {
  return (
    <>
      {parts.map((part, i) => (
        <div key={i} className="ai-insights__part">
          {/* A summary section arrives as several parts sharing one title; head the run once. */}
          {part.title && part.title !== parts[i - 1]?.title && (
            <div className="ai-insights__part-title">{part.title}</div>
          )}
          <ArtifactErrorBoundary label={part.type}>
            <AiWidgetPart part={part} />
          </ArtifactErrorBoundary>
        </div>
      ))}
    </>
  );
}

function AiWidgetPart({ part }: { part: MessagePart }) {
  switch (part.type) {
    case "text":
      return (
        <div className="ai-insights__text">
          <ReactMarkdown>{part.content ?? ""}</ReactMarkdown>
        </div>
      );
    case "table":
      return <ArtifactTable data={part.data} title={part.title} animate={false} />;
    case "stat":
      return <ArtifactStat data={part.data} title={part.title} animate={false} />;
    case "chart":
      return <ArtifactChart data={part.data} animate={false} />;
    case "insights":
      return <InsightsCard data={part.data as unknown as InsightsData} animate={false} />;
    default:
      // A part type the backend added without an FE release.
      return null;
  }
}
